<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="Currency">
          <a-select
            showSearch
            :disabled="listPembelian !== undefined && listPembelian.length > 0"
            @change="handleMataUang"
            v-decorator="[
              'mata_uang',
              {
                rules: [{ required: true }],
                initialValue: initialData.mata_uang,
              },
            ]"
          >
            <a-select-option
              v-for="item in getAllMataUang"
              :key="item.code"
              :value="item.code"
              >{{ item.code }} - {{ item.currency }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--        listPembelian!==undefined && listPembelian.length>0-->
        <a-form-item>
          <span slot="label"
            >Exchange Rate 1,00 {{ initialData.mata_uang }} to IDR</span
          >
          <a-input-number
            type="number"
            class="m-width-full m-text-align right"
            :min="1"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            v-decorator="[
              'kurs_to_idr',
              {
                rules: [{ required: true }, { validator: checkPrice }],
                initialValue: initialData.kurs_to_idr,
              },
            ]"
            :disabled="initialData.mata_uang === 'IDR' || initialExchange"
          />
        </a-form-item>
        <a-form-item>
          <span slot="label">Downpayment</span>
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'downpayment',
              {
                rules: [{ required: false }, { validator: checkPrice }],
                initialValue: initialData.downpayment,
              },
            ]"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Keuangan",
  components: {},
  props: {
    data: {},
    listPembelian: {},
    mode: String,
  },
  data() {
    return {};
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    // this.form = form;
  },
  created() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
  },
  computed: {
    ...mapGetters(["getAllMataUang"]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          mata_uang: "IDR",
          kurs_to_idr: 1,
          downpayment: 0,
        };
      } else {
        return {
          mata_uang: this.data.mata_uang,
          kurs_to_idr: this.data.kurs_to_idr,
          downpayment: this.data.downpayment,
        };
      }
    },
    initialExchange() {
      if (this.mode == "Create") {
        return false;
      } else {
        let isTerpakai = false;
        if (this.listPembelian !== undefined && this.listPembelian.length > 0) {
          this.listPembelian.forEach((data) => {
            if (
              data.values.pemakaian &&
              parseFloat(data.values.pemakaian) > 0
            ) {
              isTerpakai = true;
            }
          });
        }
        return (
          this.listPembelian !== undefined &&
          this.listPembelian.length > 0 &&
          isTerpakai
        );
      }
    },
  },
  methods: {
    handleMataUang(kurs) {
      if (kurs === "IDR") {
        this.form.setFieldsValue({
          kurs_to_idr: 1,
        });
      }
      this.initialData.mata_uang = kurs;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("ppData", { keuangan: values });
      });
    },
    checkPrice(rule, value, callback) {
      if (value >= 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
  },
};
</script>

<style>
</style>